import { useState } from 'react'
import HorizontalScroller from '@/components/HorizontalScroller'
import CategoryButton, { CategoryButtonVariant } from './CategoryButton'

export interface CategoryItem {
  id: string
  label: string
}

interface CategoryHorizontalScrollerProps {
  categories: CategoryItem[]
  initialActiveCategory?: string
  onCategoryClick?: (categoryId: string) => void
  width?: number
  variant?: CategoryButtonVariant
  contentAlign?: 'center' | 'start'
  showFadeMask?: boolean
  arrowButtonSize?: 'large' | 'medium' | 'small'
  arrowIconVariant?: 'chevron' | 'line'
  arrowPlacement?: 'inside' | 'outside' | 'edge'
  arrowVisibility?: 'hover' | 'always'
  edgeClearance?: 'overlap' | 'full'
  onArrowStateChange?: (state: { left: boolean; right: boolean }) => void
}

function CategoryHorizontalScroller({
  categories,
  initialActiveCategory,
  onCategoryClick,
  width,
  variant = 'default',
  contentAlign = 'center',
  showFadeMask = true,
  arrowButtonSize = 'small',
  arrowIconVariant = 'chevron',
  arrowPlacement = 'inside',
  arrowVisibility = 'hover',
  edgeClearance = 'overlap',
  onArrowStateChange,
}: CategoryHorizontalScrollerProps) {
  const [activeCategory, setActiveCategory] = useState(
    initialActiveCategory || categories[0]?.id || ''
  )

  const handleCategoryClick = (categoryId: string) => {
    setActiveCategory(categoryId)
    onCategoryClick?.(categoryId)
  }

  return (
    <HorizontalScroller
      width={width}
      arrowPlacement={arrowPlacement}
      arrowVisibility={arrowVisibility}
      edgeClearance={edgeClearance}
      onArrowStateChange={onArrowStateChange}
      arrowVerticalPosition="center"
      contentHeight={28}
      arrowButtonSize={arrowButtonSize}
      arrowIconVariant={arrowIconVariant}
      contentAlign={contentAlign}
      showFadeMask={showFadeMask}
    >
      {categories.map(category => (
        <CategoryButton
          key={category.id}
          label={category.label}
          isActive={activeCategory === category.id}
          onClick={() => handleCategoryClick(category.id)}
          variant={variant}
        />
      ))}
    </HorizontalScroller>
  )
}

export default CategoryHorizontalScroller
